
  const topics = [
    "/ordini/nuovo_ordine",
    "/ordini/chiudi_ordine",
    "/ordini/aggiorna_ordine",
    "/stampanti/stampanti_off",
    "/ordini/aggiorna_ordine_ombrellone",

  ];
  module.exports = topics;